import { LEVEL } from '_utils/level';

export const _LOAD_LETREX_MODEL_ = 'Load:LetrexPuzzle';

export const TYPE_SLUG = 'letrex';

export const CELL_SIZE = 60;

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  text: null,
};

export const WORD_LENGTH_BOUNDS = {
  MIN: 3,
  DEFAULT_MIN: 3,
  DEFAULT_MAX: 8,
};

export const DEFAULT_SETTINGS = {
  generation_mode: 'simple',
  min_word_length: WORD_LENGTH_BOUNDS.DEFAULT_MIN,
  max_word_length: WORD_LENGTH_BOUNDS.DEFAULT_MAX,
  prioritize_quality: true,
  avoid_similar_words: true,
  words_list: '',
};

export const GENERATION_MODES = {
  SIMPLE: 'simple',
  DISTRIBUTION: 'distribution',
};

export const GENERATION_MODE_OPTIONS = [
  {
    slug: GENERATION_MODES.SIMPLE,
    labelKey: 'letrex.form.generationMode.options.simple',
  },
  {
    slug: GENERATION_MODES.DISTRIBUTION,
    labelKey: 'letrex.form.generationMode.options.distribution',
  },
];

export const getGenerationModeOption = slug =>
  GENERATION_MODE_OPTIONS.find(option => option.slug === slug) ||
  GENERATION_MODE_OPTIONS[0];

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 9,
  rows: 10,
  columns: 10,
  level: LEVEL.MEDIUM,
  settings: { ...DEFAULT_SETTINGS },
  table: [],
};

export const MIN_DIMENSIONS = {
  ROWS: 5,
  COLUMNS: 5,
};

export const MAX_DIMENSIONS = {
  ROWS: 50,
  COLUMNS: 50,
};

export const clampDimension = (value, min, max, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  return Math.min(Math.max(parsed, min), max);
};

export const createEmptyCell = (x, y) => ({
  ...CELL,
  id: `cell-${x}-${y}`,
  positionx: x,
  positiony: y,
  text: null,
});

export const buildEmptyTable = (rows, columns, currentTable = []) => {
  const byPosition = new Map(
    currentTable.map(c => [
      `${Number(c.positionx)},${Number(c.positiony)}`,
      c,
    ]),
  );
  const table = [];

  for (let y = 0; y < rows; y += 1) {
    for (let x = 0; x < columns; x += 1) {
      const existing = byPosition.get(`${x},${y}`);

      if (existing) {
        table.push({
          ...createEmptyCell(x, y),
          id: existing.id || `cell-${x}-${y}`,
          positionx: x,
          positiony: y,
          text: existing.text || null,
        });
      } else {
        table.push(createEmptyCell(x, y));
      }
    }
  }

  return table;
};
